export default __webpack_public_path__ + "static/media/expiredTransaction.c38c1e96.gif";